import React, { useContext } from 'react'
import { GlobalStyle } from './globalStyle'
import '@fontsource/roboto-slab'
import Router from './router'
import { UserProvider } from './contexts/UserContext'
import { StockProvider } from './contexts/StockContext'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { SectionProvider } from './contexts/SectionContext'
import { ImportFromExcelProvider } from './contexts/ImportFromExcelContext'
import { TableFiltersProvider } from './contexts/TableFiltersContext'
import { ModalProvider } from './contexts/ModalContext'
import { OrdersProvider } from './contexts/OrdersContext'
import { ParametersProvider } from './contexts/ParametersContext'
import { CertificatesProvider } from './contexts/CertificatesContext'
import Compose from './contexts/Compose'
import { ProfileProvider } from './contexts/AccessesContext'
import { SearchAccessesProvider } from './contexts/SearchAccessesContext'
import { FeedbackContext, FeedbackProvider } from './contexts/FeedbackContext'
import { ServicesProvider } from './contexts/ServicesContext'
import { ProductionUserProvider } from './contexts/ProductionUser'
import { MachineProvider } from './contexts/MachineContext'
import { QrCodeProvider } from './contexts/QRCodeContext'
import { ReportProvider } from './contexts/ReportContext'
import './config/axios'
import { FreightProvider } from './contexts/FreightContext'
import { VehicleProvider } from './contexts/VehicleContext'
import { ClientProvider } from './contexts/ClientContext'
import { RouterProvider } from './contexts/RouterContext'
import { RouterInfoProvider } from './contexts/RouterInfoContext'

const App: React.FC = () => {
  return (
    <>
      <GoogleOAuthProvider clientId='963662575465-hbce4u67fa4t8q4acma8biosc8if50te.apps.googleusercontent.com'>
        <UserProvider>
          <Compose components={[
            SectionProvider, 
            ModalProvider, 
            FeedbackProvider,
            TableFiltersProvider, 
            StockProvider, 
            OrdersProvider, 
            ImportFromExcelProvider,
            SearchAccessesProvider,
            ProfileProvider,
            CertificatesProvider,
            ParametersProvider,
            ServicesProvider,
            ProductionUserProvider,
            MachineProvider,
            ReportProvider,
            QrCodeProvider,
            FreightProvider,
            VehicleProvider,
            ClientProvider,
            RouterProvider,
            RouterInfoProvider
          ]}>
            <GlobalStyle/>
            <Router />
          </Compose>
        </UserProvider>
      </GoogleOAuthProvider>
    </>
  )
}

export default App
